(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
      this.bindNavClose();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    bindNavClose() {
      // close any open mega dropdown when clicking outside it or pressing escape
      const dds = this.querySelectorAll('.sdh__dd');
      document.addEventListener('click', (event) => {
        dds.forEach((dd) => {
          if (dd.hasAttribute('open') && !dd.contains(event.target)) dd.removeAttribute('open');
        });
      });
      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        dds.forEach((dd) => dd.removeAttribute('open'));
      });
      dds.forEach((dd) => {
        dd.addEventListener('toggle', () => {
          if (!dd.open) return;
          dds.forEach((other) => {
            if (other !== dd) other.removeAttribute('open');
          });
        });
      });
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu, .sdh__dd');
      this.disclosures.forEach((disclosure) => {
        if (disclosure.close) disclosure.close();
        else disclosure.removeAttribute('open');
      });
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sd-heritage"] && !Shopify.designMode) return;
  try {
    
(function () {
  var fan = document.getElementById('sdxHerFan');
  if (!fan) return;
  var cards = [].slice.call(fan.querySelectorAll('.sdx-her__card'));
  var cap = document.getElementById('sdxHerCap');
  var n = cards.length;
  var HALF = 3;
  var VISIBLE = Math.min(7, n);
  var center = 3; // Paul opens in the middle
  var busy = false;

  var SLOTS = [
    { rot: -21, scale: 0.7756, x: -30, y: 7.3, z: 1 },
    { rot: -14, scale: 0.8498, x: -22, y: 4.0, z: 2 },
    { rot: -7,  scale: 0.9346, x: -11, y: 1.3, z: 3 },
    { rot: 0,   scale: 1.0,    x: 0,   y: 0.0, z: 10 },
    { rot: 7,   scale: 0.9346, x: 11,  y: 1.3, z: 3 },
    { rot: 14,  scale: 0.8498, x: 22,  y: 4.0, z: 2 },
    { rot: 21,  scale: 0.7756, x: 30,  y: 7.3, z: 1 }
  ];

  function mult() {
    var w = window.innerWidth;
    if (w < 480) return 0.26;
    if (w < 640) return 0.36;
    if (w < 768) return 0.48;
    if (w < 1024) return 0.72;
    return 1;
  }

  function render() {
    var m = mult();
    var slotOf = {};
    for (var s = 0; s < VISIBLE; s++) {
      slotOf[((center + s - HALF) % n + n) % n] = s;
    }
    cards.forEach(function (card, i) {
      var s = slotOf[i];
      if (s !== undefined) {
        var p = SLOTS[s];
        card.style.opacity = '1';
        card.style.zIndex = p.z;
        card.style.transform = 'translate(' + (p.x * m) + 'rem,' + p.y + 'rem) rotate(' + p.rot + 'deg) scale(' + p.scale + ')';
        card.style.pointerEvents = 'auto';
      } else {
        var rel = ((i - center) % n + n) % n;
        var side = rel > n / 2 ? -1 : 1;
        card.style.opacity = '0';
        card.style.zIndex = 0;
        card.style.transform = 'translate(' + (side * 38 * m) + 'rem,2rem) rotate(' + (side * 26) + 'deg) scale(0.45)';
        card.style.pointerEvents = 'none';
      }
    });
    cap.textContent = cards[center].getAttribute('data-cap');
  }

  function cycle(d) {
    if (busy) return;
    busy = true;
    setTimeout(function () { busy = false; }, 480);
    center = ((center + d) % n + n) % n;
    render();
  }

  document.getElementById('sdxHerPrev').addEventListener('click', function () { cycle(-1); });
  document.getElementById('sdxHerNext').addEventListener('click', function () { cycle(1); });

  var tx = null;
  fan.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; }, { passive: true });
  fan.addEventListener('touchend', function (e) {
    if (tx === null) return;
    var dx = e.changedTouches[0].clientX - tx;
    if (Math.abs(dx) > 40) cycle(dx < 0 ? 1 : -1);
    tx = null;
  }, { passive: true });

  var rt = null;
  window.addEventListener('resize', function () {
    clearTimeout(rt);
    rt = setTimeout(render, 150);
  });

  render();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sd-hero-cinema"] && !Shopify.designMode) return;
  try {
    
(function () {
  var roots = document.querySelectorAll('[data-sdc]');
  roots.forEach(function (root) {
    if (root.getAttribute('data-sdc-bound')) return;
    root.setAttribute('data-sdc-bound', '1');
    var scenes = [].slice.call(root.querySelectorAll('[data-sdc-scene]'));
    var panels = [].slice.call(root.querySelectorAll('[data-sdc-panel]'));
    var btns = [].slice.call(root.querySelectorAll('[data-sdc-btn]'));
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var active = 0;
    var busy = false;

    function setH() {
      var top = root.getBoundingClientRect().top + (window.scrollY || window.pageYOffset);
      root.style.setProperty('--sdc-h', 'calc(100svh - ' + Math.max(0, Math.round(top)) + 'px)');
    }
    setH();
    window.addEventListener('resize', setH);
    window.addEventListener('load', setH);

    function portraitMode() {
      return window.matchMedia('(max-aspect-ratio: 4/5)').matches;
    }

    function ensureVideo(i) {
      if (reduced) return null;
      var scene = scenes[i];
      var src;
      if (portraitMode()) {
        src = scene.getAttribute('data-video-portrait') || scene.getAttribute('data-video-landscape');
      } else {
        src = scene.getAttribute('data-video-landscape');
      }
      if (!src) return null;
      var v = scene.querySelector('video');
      if (!v) {
        v = document.createElement('video');
        v.muted = true;
        v.loop = true;
        v.playsInline = true;
        v.setAttribute('playsinline', '');
        v.setAttribute('muted', '');
        v.preload = 'metadata';
        scene.appendChild(v);
      }
      if (v.getAttribute('data-current-src') !== src) {
        v.src = src;
        v.setAttribute('data-current-src', src);
      }
      return v;
    }

    function activate(i, instant) {
      active = i;
      scenes.forEach(function (s, k) { s.classList.toggle('is-on', k === i); });
      panels.forEach(function (p, k) {
        var on = k === i;
        p.classList.toggle('is-on', on);
        if (on) { p.removeAttribute('inert'); } else { p.setAttribute('inert', ''); }
      });
      btns.forEach(function (b, k) {
        b.classList.toggle('is-on', k === i);
        b.setAttribute('aria-current', k === i ? 'true' : 'false');
      });
      var v = ensureVideo(i);
      if (v) {
        var pr = v.play();
        if (pr && pr.catch) pr.catch(function () {});
      }
      scenes.forEach(function (s, k) {
        if (k === i) return;
        var ov = s.querySelector('video');
        if (ov) setTimeout(function () { ov.pause(); }, instant ? 0 : 1050);
      });
    }

    btns.forEach(function (b, i) {
      b.addEventListener('click', function () {
        if (busy || i === active) return;
        busy = true;
        setTimeout(function () { busy = false; }, 1000);
        activate(i);
      });
    });

    activate(0, true);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sd-sleep-selector"] && !Shopify.designMode) return;
  try {
    
(function(){
  // Origin check is on the MESSAGE SENDER (the quiz app's own origin), not the
  // parent page, so this is unaffected by which host the parent renders from
  // (live sleepdoctorgriffith.com.au or the same host with ?preview_theme_id=).
  var ORIGIN = 'https://sd-mattress-match.netlify.app';
  var MIN_H = 300, MAX_H = 4000;

  // Sane initial height per viewport, applied before the first real height
  // message arrives. The ported app's content reflows much taller on narrow
  // viewports (intro + trust row + carousel stack vertically), so the
  // section's configurable min_height (tuned for desktop) is not tall enough
  // on phones and clips "Start Matching" below the fold with nothing visible
  // to scroll, since the iframe used to ship with scrolling="no". Now that
  // internal scrolling is allowed as a fallback too, this is a belt-and-braces
  // improvement, not the only thing standing between a visitor and a clipped
  // quiz.
  function applyInitialHeight(f){
    var base = parseInt(f.getAttribute('data-default-height'), 10) || 760;
    var isPhone = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
    var h = isPhone ? Math.max(base, 1200) : base;
    f.style.height = h + 'px';
  }
  document.querySelectorAll('.sdq-frame').forEach(applyInitialHeight);

  window.addEventListener('message', function(e){
    if (e.origin !== ORIGIN) return;
    var d = e.data || {};
    if (d.source !== 'sd-mattress-match') return;
    var frames = document.querySelectorAll('.sdq-frame');
    for (var i = 0; i < frames.length; i++){
      var f = frames[i];
      if (f.contentWindow !== e.source) continue;
      if (d.type === 'height' && d.height){
        var h = Math.min(MAX_H, Math.max(MIN_H, Math.ceil(d.height)));
        f.style.height = h + 'px';
      } else if (d.type === 'scrollIntoView'){
        var rect = f.getBoundingClientRect();
        if (rect.top < 60 || rect.top > 160){
          window.scrollTo({ top: window.pageYOffset + rect.top - 90, behavior: 'smooth' });
        }
      }
    }
  }, false);
})();

  } catch(e) { console.error(e); }
})();
})();
